/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../../lib/OzComponent';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken, getParams, removeUrlParam } from '../../utils/util';
import './EditableCompany.css';
import Wrapper from '../Wrapper';
import LocationForm from './LocationForm';
import DeleteRoomForm from './DeleteRoomForm';
import MarkDuplicateForm from './MarkDuplicateForm';
import IntegrationForm from './IntegrationForm';
import OzModalButton from './OzModalButton';
import { SITE_DOMAIN, API_HOST, STRIPE_CLIENT_ID, STRIPE_REDIRECT_URI } from '../../config';

import {
  getCompany,
  listCompanies,
  updateRoom,
  addIntegration,
  pullMyData,
  addLocation,
  updateLocation,
  markDupes,
} from '../../actions';


class BookeoIntegration extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    let params = getParams();
    let delta = {};

    console.log('DELTA params:', params);
    console.log('DELTA props:', this.props, this.props.forSystem);

    if (this.props.forSystem == 'bookeo' && params.state == 'bookeo') {
      delta.adding = true;
      delta.apiKey = params.apiKey;
    } else if (this.props.forSystem == 'checkfront' && params.state == 'checkfront') {
      delta.adding = true;
      delta.code = params.code;
    }
    console.log('DELTA', delta);
    this.setState(delta);
  }

  addIntegration(e, values) {
    console.log('add integration', values);
    this.props.addIntegration(values)
      .then(resp => {
        console.log('add integration resp', resp);
        if (resp.error) return;
        removeUrlParam(['state', 'apiKey']);
        this.setState({ adding: false });
        this.props.onComplete()
          .then(() => {
            NotificationManager.success('Added ' + this.props.name);
          });
      });
  }

  renderAddIntegration() {
    let company = this.props.company;
    if (!company) return;
    let name = this.props.name;

    return (
      <div>
        <Modal show={this.state.adding}>
          <Modal.Header closeButton onHide={() => this.setState({ adding: false })}>
            <Modal.Title>{name}</Modal.Title>
          </Modal.Header>
          <IntegrationForm
            modal
            errors={this.props.errors.addIntegration}
            values={{ bookingSystem: this.props.forSystem,
                      accessToken: this.state.apiKey,
                      code: this.state.code,
                      companyId: company.id
                    }}
            onSubmit={(e, values) => this.addIntegration(e, values)}
            onCancel={(e, values) => this.setState({ adding: false })}
            buttonText="Add Integration"
            cancelText="Cancel"
            company={company}
            locations={company.locations}
          />
        </Modal>
      </div>
    )
  }

  render() {
    let url = this.props.url;
    let name = this.props.name;

    return (
      <div className="bookeo">
        {this.renderAddIntegration()}
        <a href={url}><Button><FontAwesome name="plus-square"/> {name}</Button></a>
      </div>
    );
  }
}


class EditableRoom extends Component {
  state = {};

  refresh() {
    return this.props.onComplete();
  }

  deleteHide(e, values) {
    let room = this.props.room;

    this.props.updateRoom(room.id, values)
      .then(resp => {
        if (resp.error) return;
        this.refresh()
          .then(() => this.setState({ deleting: false }));
      });
  }

  renderDeleteNode() {
    let room = this.props.room;

    return (
      <OzModalButton
        modalTitle={'Delete/Hide ' + room.name}
        show={this.state.deleting}
        onShow={() => this.setState({ deleting: true })}
        onHide={() => this.setState({ deleting: false })}
        >

        <Button bsSize="small">Delete/Hide</Button>

        <DeleteRoomForm
          modal={true}
          values={{}}
          errors={this.props.errors.deleteRoom}
          onCancel={() => this.setState({ deleting: false })}
          onSubmit={(e, values) => this.deleteHide(e, values)}
          buttonText="Delete/Hide"
          cancelText="Cancel"
        />
      </OzModalButton>
    );
  }

  markDupes(e, values) {
    console.log('mark dupes:', values);
    this.props.markDupes(values)
      .then(resp => {
        if (resp.error) return;
        this.setState({ markingDupe: false });
        this.refresh()
          .then(() => NotificationManager.success('Marked duplicates'));
      });
  }

  renderMarkDuplicateNode() {
    let room = this.props.room;

    return (
      <OzModalButton
        modalTitle={'Mark as Duplicate'}
        show={this.state.markingDupe}
        onShow={() => this.setState({ markingDupe: true })}
        onHide={() => this.setState({ markingDupe: false })}
        >

        <Button bsSize="small">Mark as Duplicate</Button>

        <MarkDuplicateForm
          modal={true}
          values={{ roomId: room.id }}
          errors={this.props.errors.markDuplicate}
          onCancel={() => this.setState({ markingDupe: false })}
          onSubmit={(e, values) => this.markDupes(e, values)}
          buttonText="Mark as Duplicate"
          cancelText="Cancel"
          room={room}
        />
      </OzModalButton>
    );
  }

  render() {
    let room = this.props.room;
    let viewUrl = '/r/' + room.slug + '/' + room.id;
    let manageUrl = '/r/' + room.slug + '/' + room.id + '/manage';

    let timeSlotsNode;
    let count = room.numFutureTimeSlots
    let timeSlotCopy;
    if (count > 0) {
      timeSlotsNode = (
        <div className="time-slot-status ok">
          <FontAwesome name="check-circle" /> Found <b>{count} time slot{count == 1 ? '' : 's'}</b>
        </div>
      );
    } else {
      timeSlotsNode = (
        <div className="time-slot-status empty">
          <FontAwesome name="exclamation-triangle" /> No time slots found
        </div>
      );
    }

    let bookingSystemNode;
    if (room.bookingSystem) {
      bookingSystemNode = (
        <div className="time-slot-status ok">
          <FontAwesome name="check-circle" /> Connected to <b>{room.bookingSystem}</b>
        </div>
      );
    }

    let infoNodes = [];
    let keys = [
      ['minPeople', 'Min players'],
      ['maxPeople', 'Max players'],
      ['images', 'Images', v => v.length],
      ['privacy', 'Privacy'],
    ];
    for (let key of keys) {
      let v = room[key[0]];
      let val = key.length == 2 ? v : key[2](v);
      if (val) {
        infoNodes.push(<li key={key[0]}><b>{key[1]}</b>: {val}</li>);
      } else {
        infoNodes.push(<li key={key[0]}><b><FontAwesome name="exclamation-triangle" /> {key[1]}</b>: missing</li>);
      }
    }

    let roomNode = (
      <div key={room.id} className={cx('location-room', { disabled: room.disabled})}>
        {room.disabled && <div><b>Disabled:</b> {room.prettyDisabledReason}</div>}
        {room.duplicateOf && <div><b>Duplicate of: </b>{room.duplicateOf.name} ({room.duplicateOf.id})</div>}
        <div className="location-room-info">
          <div className="location-room-name">{room.name}</div>
          {bookingSystemNode}
          {timeSlotsNode}
          <div>
            Details:
            <ul>{infoNodes}</ul>
          </div>
        </div>
        <div className="controls">
          <Link to={viewUrl}><Button bsSize="small">View On Site</Button></Link>{' '}
          {this.renderDeleteNode()}
          {this.renderMarkDuplicateNode()}
          <Link to={manageUrl}><Button bsSize="small">Edit</Button></Link>
        </div>
      </div>
    );
    return roomNode;
  }
}


class EditableCompany extends Component {
  state = {};

  isOwner() {
    if (!this.props.user) return false;
    if (!this.props.company) return false;
    if (!this.props.company.owner) return false;
    return this.props.company.owner.id == this.props.user.id;
  }

  componentDidMount() {
    this.props.getCompany(this.props.companyId);
  }

  refreshCompany() {
    return this.props.getCompany(this.props.companyId, { background: true });
  }

  addLocation(e, values) {
    console.log('add location:', values);
    values.companyId = this.props.company.id;
    this.props.addLocation(values)
      .then(resp => {
        console.log('add location resp', resp);
        this.refreshCompany()
          .then(() => {
            this.setState({ addingLocation: false });
          });
      });
  }

  saveLocation(e, values) {
    console.log('save location:', values);
    this.props.updateLocation(this.state.editingLocationId, values)
      .then(resp => {
        console.log('save resp:', resp);
        if (resp.error) return;

        this.refreshCompany()
          .then(() => {
            this.setState({ editingLocationId: null });
          });
      });
  }

  pullSample() {
    this.props.pullMyData()
      .then(resp => {
        console.log('pullMyData:', resp);
        this.setState({ integrationData: resp });
        this.refreshCompany();
      });
  }

  renderSample() {
    if (!this.state.integrationData) return;

    let idx = 0;
    let nodes = this.state.integrationData.companies.map(company => {
      let locationNodes = company.locations.map(location => {

        let roomNodes = location.rooms.map(room => {
          let timeSlotNodes = room.timeSlots.map(timeSlot => {
            return (
              <li key={idx++}>
                {moment(timeSlot.datetime).format('MMM Do, h:mma')} - {timeSlot.status} ({timeSlot.slotsLeft} available)
              </li>
            )
          });

          return (
            <li key={idx++}>
              <div>{room.name} - ({room.extId})</div>
              <ul>{timeSlotNodes}</ul>
            </li>
          )
        });

        return (
          <li key={idx++}>
            <div>{location.address} ({location.extId})</div>
            <ul>{roomNodes}</ul>
          </li>
        );
      });

      return (
        <li key={idx++}>
          <div>({company.extId})</div>
          <ul>{locationNodes}</ul>
        </li>
      );
    });

    return (
      <div>
        <ul>{nodes}</ul>
      </div>
    );
  }

  renderIntegrations() {
    if (!this.isOwner()) return;

    let company = this.props.company;

    let integrationNodes = company.integrations.map(integration => {
      let locationNode = null;
      if (integration.location) {
        locationNode = <span> - {integration.location.address}</span>;
      }
      return (
        <li key={integration.id} className="integration">
          <FontAwesome name="check-circle"/> {integration.bookingSystem} {locationNode} <span className="integration-type">data</span>
        </li>
      );
    });

    let showNoIntegrations = integrationNodes.length == 0;
    let showNoTimes = !showNoIntegrations && !company.hasFutureTimeSlots;

    let bookeoUrl = 'https://signin.bookeo.com/?authappid=TPUPL97WM96P&permissions=bookings_r_all,blocks_r_all,availability_r&state=bookeo';
    let bookeoBookingUrl = 'https://signin.bookeo.com/?authappid=TPUPL97WM96P&permissions=availability_r,bookings_rw_all,blocks_r_all,blocks_rw_all,customers_rw_own&state=bookeo';

    let checkfrontUrl = 'https://escapespy.checkfront.co.uk/oauth/?client_id=828689b9e54bd6862c9920456f0fe0a521a49b89&response_type=code&redirect_uri=https://www.escapespy.com/manage&state=checkfront';

    let pullSampleNode;
    if (integrationNodes.length > 0) {
      pullSampleNode = (
        <div className="pull-sample">
          <p>Test your integration by pulling sample data:</p>
          <div><Button onClick={() => this.pullSample()}>Pull Sample Data</Button></div>
        </div>
      );
    }

    let addIntegrationNode;
    if (integrationNodes.length == 0) {
      addIntegrationNode = (
        <div>
          <BookeoIntegration
            name="Bookeo Data Integration"
            forSystem="bookeo"
            url={bookeoUrl}
            onComplete={() => this.refreshCompany()}
            {...this.props}
          />

          <BookeoIntegration
            name="Checkfront Data Integration"
            forSystem="checkfront"
            url={checkfrontUrl}
            onComplete={() => this.refreshCompany()}
            {...this.props}
          />
        </div>
      );
    }

    let hasBookingIntegration = false;
    let bookingIntegrationNodes = [];
    for (let integration of company.integrations) {
      if (integration.permissions.includes('booking')) {
        hasBookingIntegration = true;
        let locationNode = null;
        if (integration.location) {
          locationNode = <span> - {integration.location.address}</span>;
        }
        let node = (
          <li key={integration.id} className="integration">
            <FontAwesome name="check-circle"/> {integration.bookingSystem} {locationNode} <span className="integration-type">booking</span>
          </li>
        );
        bookingIntegrationNodes.push(node);
      }
    }

    let addBookingIntegrationNode;
    if (false && !hasBookingIntegration) {
      addBookingIntegrationNode = (
        <div>
          <BookeoIntegration
            name="Bookeo Booking Integration"
            forSystem="bookeo"
            url={bookeoBookingUrl}
            onComplete={() => this.refreshCompany()}
            {...this.props}
          />
        </div>
      );
    }

    return (
      <div>
        {showNoIntegrations && <div className="no-integrations">
         <div className="no-integrations-header"><FontAwesome name="exclamation-triangle"/> No booking system connected</div>
         <div className="no-integrations-sub">Connect booking system below to ensure an up-to-date listing.</div>
         </div>}

        {showNoTimes && <div className="no-times">
         <div className="no-times-header"><FontAwesome name="exclamation-triangle"/> No time slots found for {company.name}</div>
         <div className="no-times-sub">Contact support using the chat box to fix this.</div>
         </div>}

        <div className="company-sources integration-sources">
          <div className="gray-small-caps-header">Data Integrations</div>
          {integrationNodes.length == 0 && <div><p>Connect your booking system to import all your rooms and time slots. This will ensure that your listings on EscapeSpy are always up to day, and you never have to worry about updating them on different websites.</p><p>This is a read-only integration, and your data will not be modified in any way.</p></div>}
          {integrationNodes.length > 0 && <div>
           <p>You have added these integrations for time slot information.</p>
           <ul>{integrationNodes}</ul>
           </div>}

           {pullSampleNode}
           {this.renderSample()}

           {addIntegrationNode}
        </div>

        {/*
        <div className="company-sources integration-sources">
          <div className="gray-small-caps-header">Booking Integration</div>
          <div>
            <p>
              Allow players to book times directly on EscapeSpy.
            </p>
          </div>
          <div><ul>{bookingIntegrationNodes}</ul></div>
          {addBookingIntegrationNode}
          {this.renderStripe()}
         </div>
         */}
      </div>
    );
  }

  renderScraperSources() {
    let company = this.props.company;
    let ssNodes = company.scraperSources.map(ss => {
      return (
        <li key={ss.id}>
          <b>{ss.bookingSystem}:</b> {ss.bookingId}
        </li>
      );
    });
    return (
      <div className="company-sources">
        <div className="gray-small-caps-header">Scraper Sources</div>
        <p>EscapeSpy uses the identifiers below to pull time slot information for your listing.</p>
        {ssNodes.length == 0 && <ul><li>None found</li></ul>}
        {ssNodes.length > 0 && <ul>{ssNodes}</ul>}
        <p>To make changes to this list, please use the chat button to contact support.</p>
      </div>
    )
  }

  renderStripe() {
    let company = this.props.company;
    if (!company) return;

    let node;
    if (company.stripe) {
      node = <div><FontAwesome name="check-circle" /> Stripe is connected</div>;
    } else {
      // let stripeUrl = 'https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=' + STRIPE_CLIENT_ID + '&state=stripe&redirect_uri=' + STRIPE_REDIRECT_URI;
      let stripeUrl = 'https://connect.stripe.com/oauth/authorize?response_type=code&client_id=' + STRIPE_CLIENT_ID + '&scope=read_write&state=stripe&redirect_uri=' + STRIPE_REDIRECT_URI;
      node = <div><a href={stripeUrl}><Button>Connect Stripe</Button></a></div>;
    }

    return (
      <div className="stripe">
        {node}
      </div>
    );
  }

  render() {
    let company = this.props.company;
    let user = this.props.user;
    if (!company || !user) return <div/>;

    let nodes = [];
    for (let location of company.locations) {
      let roomNodes = [];
      let rooms = location.rooms;
      rooms.sort((a, b) => a.name.localeCompare(b.name));
      for (let room of rooms) {
        let roomNode = <EditableRoom
                         key={room.id}
                         room={room}
                         onComplete={() => this.refreshCompany()}
                         {...this.props}
                       />;
        roomNodes.push(roomNode);
      }

      let regionNodes = location.regions.map(region => {
        return (
          <div key={region.slug} className="region">
            <Link to={'/region/' + region.slug}>{region.name}</Link>
          </div>
        );
      });

      let node = (
        <div key={location.id} className="company-location">
          <div className="company-location-info">
            <div className="company-location-address">
              <div>{location.address}</div>
              <div className="regions">{regionNodes}</div>
              {user.isStaff && <div className="location-id admin">Location ID: {location.id} <a href={API_HOST + '/api/flyer-pdf?location=' + location.id}><Button>Get Flyer PDF</Button></a></div>}
            </div>
            <div className="controls">
              <OzModalButton
                modalTitle="Edit Location"
                show={this.state.editingLocationId == location.id}
                onShow={() => this.setState({ editingLocationId: location.id })}
                onHide={() => this.setState({ editingLocationId: null })}
                >
                <Button>Edit Location</Button>

                <LocationForm
                  modal={true}
                  values={location}
                  errors={this.props.errors.location}
                  onCancel={() => this.setState({ editingLocationId: null })}
                  onSubmit={(e, values) => this.saveLocation(e, values)}
                  buttonText="Save"
                  cancelText="Cancel"
                />
              </OzModalButton>
            </div>
          </div>
          <div className="company-location-rooms">{roomNodes}</div>
        </div>
      );
      nodes.push(node);
    }

    return (
      <div className="EditableCompany">
        <div className="company-info">
          <div className="company-name">{company.name}</div>

          <div className="controls">
            <OzModalButton
              modalTitle="Add Location"
              show={this.state.addingLocation}
              onShow={() => this.setState({ addingLocation: true })}
              onHide={() => this.setState({ addingLocation: false })}
            >
              <Button>Add Location</Button>

              <LocationForm
                modal={true}
                values={{}}
                errors={this.props.errors.location}
                onCancel={() => this.setState({ addingLocation: false })}
                onSubmit={(e, values) => this.addLocation(e, values)}
                buttonText="Add Location"
                cancelText="Cancel"
              />
            </OzModalButton>

            <Link to="/r/add"><Button>Add Room</Button></Link>
          </div>
        </div>

        {this.renderIntegrations()}

        <div className="company-locations">{nodes}</div>

        {this.renderScraperSources()}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.user,
    company: state.get.company,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    getCompany,
    listCompanies,
    updateRoom,
    addIntegration,
    pullMyData,
    addLocation,
    updateLocation,
    markDupes,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditableCompany);



/** WEBPACK FOOTER **
 ** ./src/components/partials/EditableCompany.js
 **/